var i4_Drag_drop = {
	draggableClass: 'draggable',
	
	create: function(params) {
		$('#'+params.id_list_1+' li').addClass(this.draggableClass);
		$('#'+params.id_list_2+' li').addClass(this.draggableClass);
		
		this.make_draggable(params);
		this.make_droppable(params);

		this.store(params);
	
	}, // i4_Drag_drop.create()
	
	make_droppable: function(params) {
		
		$('#'+params.id_list_1).droppable({ 
			accept: '.'+this.draggableClass,
			classes: {
				'ui-droppable-hover': 'hover'
			},
			drop: (function(event, ui) {

				var dropped = ui.draggable;
				var droppedOn = $('#'+params.id_list_1);
				$(dropped).detach().css({top: 0,left: 0}).appendTo(droppedOn);    
				
				this.store(params);   
			}).bind(this) 
		});
		
		$('#'+params.id_list_2).droppable({ 
			accept: '.'+this.draggableClass,
			classes: {
				'ui-droppable-hover': 'hover'
			},
			drop: (function(event, ui) {

				var dropped = ui.draggable;
				var droppedOn = $('#'+params.id_list_2);
				$(dropped).detach().css({top: 0,left: 0}).appendTo(droppedOn);    
				
				this.store(params);   
			}).bind(this)
		});
		
	},
	
	make_draggable: function(params) {
		
		$('.'+this.draggableClass).draggable({ 
			classes: {
				'ui-draggable-dragging': 'dragged'
			},
			revert: "invalid"
		});
	},
	
	store: function(params) {
		
		// store list 1
		var value = '';
		$('#'+params.id_list_1+' li').each(function(i, item){
			value += $(item).attr('id').split('_').reverse()[0]+',';
		});

		$('#'+params.id_list_1).parent().siblings('input[type=hidden].drag_drop_list_1').val(value);

		// store list 2
		// @todo...
		
	} // i4_Drag_drop.store()

}; // i4_Drag_drop
